import { httpPostSearch } from '@iconik-io/iconik-api/src/services/search';
import { prepareQueryForMainSearch } from '@iconik-io/shared-lib/src/utils/search/prepare_query_for_main_search';

import { cancellable } from '../../ducks/http/actions';
import type { AppDispatch } from '../../store/types';

export const searchRelatedCollections =
  (values: string[], query = '', perPage = 100) =>
  (dispatch: AppDispatch) =>
    dispatch(
      cancellable(
        httpPostSearch(
          {
            query: prepareQueryForMainSearch(query),
            doc_types: ['collections'],
            filter: {
              filters: [
                { operator: 'OR', terms: [{ name: 'id', value_in: values }] },
                {
                  operator: 'AND',
                  terms: [{ name: 'status', value: 'ACTIVE' }],
                },
              ],
              operator: 'AND',
            },
            sort: [{ name: 'date_created', order: 'desc' }],
          },
          { save_search_history: false, per_page: perPage },
        ),
      ),
    );
